export const APP_URL = process.env.REACT_APP_URL ?? 'https://app.asistme.ai'
export const CND_URL = process.env.REACT_APP_URL ?? 'https://files.asistme.ai'
export const API_URL = process.env.REACT_APP_API_URL ?? 'https://api.asistme.ai'
export const STRIPE_KEY =
  process.env.STRIPE_KEY ??
  'pk_live_51OWLE7FHnMgCr14LJm7AHwb4IuGI5RIyFqIFVNxBGX1kLWsqu5D6m7c4E1pLitsJEE8zPkJpVXuuJNv0hDTniud200slGU1R6E'
